function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { uuid } from "./utils/uuid";
var formatMarkName = function formatMarkName(name, t) {
  return "zen-performance_".concat(name).concat(t ? "_".concat(t) : '');
};
var getDetail = function getDetail(detail) {
  var history = JSON.parse(window.localStorage.getItem('HISTORY') || '[]');
  var _detail = _objectSpread({
    log_time: new Date().toISOString().replace(/T/, ' ').replace(/(\.\d*Z)/, ''),
    url: window.location.href,
    referrer: history[history.length - 2],
    lang: window.localStorage.getItem('I18N_LANG_LOCALE') || 'en',
    agent: navigator.userAgent
  }, detail);
  return _detail;
};
var setParamInfoEvent = 'zen-performance_setParamInfo';
var setParamInfo = function setParamInfo(detail) {
  function customUserEvent(value) {
    var event = new Event(setParamInfoEvent);
    event.key = 'paramInfo';
    event.newValue = value;
    window.dispatchEvent(event);
  }
  customUserEvent(detail);
};
var addSetParamInfoEventListener = function addSetParamInfoEventListener(eventFn) {
  function _eventFn(e) {
    eventFn(e.newValue, e);
  }
  //当前tab页有效
  window.addEventListener(setParamInfoEvent, _eventFn);
  return function () {
    window.removeEventListener(setParamInfoEvent, _eventFn);
  };
};
var sendData = function sendData(url, body) {
  fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': ' application/json',
      Accept: 'application/json',
      Authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoiY29uc29sZSIsImVudiI6IkRldiJ9.KGieJVgFh0zHdKG8wGMqWhuEv5r98u6tawzn9Uulm48'
    },
    body: JSON.stringify(body)
  });
};
if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "undefined" && window.xmlhttprequestData === undefined) {
  window.xmlhttprequestData = {};
}
export var addXmlhttprequestData = function addXmlhttprequestData(data) {
  var id = uuid();
  var time = new Date().valueOf();
  window.xmlhttprequestData[id] = _objectSpread(_objectSpread({}, data), {}, {
    id: id,
    time: time
  });
};
var cleanXmlhttprequestData = function cleanXmlhttprequestData(id) {
  delete window.xmlhttprequestData[id];
};
var findXmlhttprequestData = function findXmlhttprequestData(name) {
  var time = new Date().valueOf();
  var data = Object.values(window.xmlhttprequestData).find(function (item) {
    return item.name === name && item.time <= time + 1000 && item.time >= time - 3000;
  });
  if (data) {
    cleanXmlhttprequestData(data.id);
  }
  return data;
};

//停止记录Xmlhttprequest信息
var stopAddXmlhttprequestEntries = function stopAddXmlhttprequestEntries() {
  performance.mark(formatMarkName('stop_start', new Date().valueOf()));
};
var performanceObserver;
if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "undefined" && window.performanceData === undefined) {
  window.performanceData = {
    portalTiming: undefined,
    portalXmlhttprequestEntries: [],
    dashboardTiming: undefined,
    dashboardXmlhttprequestEntries: [],
    serviceLandingTiming: undefined,
    serviceLandingXmlhttprequestEntries: [],
    productListLandingTiming: undefined,
    productListLandingXmlhttprequestEntries: [],
    productListTiming: undefined,
    productListXmlhttprequestEntries: [],
    createTiming: undefined,
    createXmlhttprequestEntries: []
  };
}

//主项目
var portalMeasureName = formatMarkName('portal_timing');
var portal = /*#__PURE__*/_createClass(function portal(t) {
  var _this = this;
  _classCallCheck(this, portal);
  _defineProperty(this, "t", void 0);
  _defineProperty(this, "startName", void 0);
  _defineProperty(this, "endName", void 0);
  _defineProperty(this, "portalStart", function () {
    window.performanceData.portalTiming = undefined;
    window.performanceData.portalXmlhttprequestEntries = [];
    performance.mark(_this.startName);
  });
  _defineProperty(this, "portalEnd", function () {
    var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var startObserve = performance.getEntriesByName(_this.startName);
    if (startObserve.length > 0) {
      setParamInfo(detail);
      performance.mark(_this.endName);
      performance.measure(portalMeasureName, _this.startName, _this.endName);
    }
  });
  this.t = t || new Date().valueOf();
  this.startName = formatMarkName('portal_start', this.t);
  this.endName = formatMarkName('portal_end', this.t);
}); //dashboard
var dashboardMeasureName = formatMarkName('dashboard_timing');
var dashboard = /*#__PURE__*/_createClass(function dashboard(intInitnum, t) {
  var _this2 = this;
  _classCallCheck(this, dashboard);
  _defineProperty(this, "intInitnum", void 0);
  _defineProperty(this, "t", void 0);
  _defineProperty(this, "startName", void 0);
  _defineProperty(this, "endName", void 0);
  _defineProperty(this, "currentStep", 0);
  _defineProperty(this, "dashboardStart", function () {
    window.performanceData.dashboardTiming = undefined;
    window.performanceData.dashboardXmlhttprequestEntries = [];
    _this2.currentStep = 0;
    performance.mark(_this2.startName);
  });
  _defineProperty(this, "dashboardForward", function () {
    _this2.currentStep += 1;
    if (_this2.currentStep === _this2.intInitnum) {
      _this2.dashboardEnd();
    }
  });
  _defineProperty(this, "dashboardEnd", function () {
    var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var startObserve = performance.getEntriesByName(_this2.startName);
    if (startObserve.length > 0) {
      setParamInfo(getDetail(detail));
      performance.mark(_this2.endName);
      performance.measure(dashboardMeasureName, _this2.startName, _this2.endName);
    }
  });
  this.intInitnum = intInitnum;
  this.t = t || new Date().valueOf();
  this.startName = formatMarkName('dashboard_start', this.t);
  this.endName = formatMarkName('dashboard_end', this.t);
}); //子项目landing
var serviceLandingMeasureName = formatMarkName('serviceLanding_timing');
var serviceLanding = /*#__PURE__*/_createClass(function serviceLanding(t) {
  var _this3 = this;
  _classCallCheck(this, serviceLanding);
  _defineProperty(this, "t", void 0);
  _defineProperty(this, "startName", void 0);
  _defineProperty(this, "endName", void 0);
  _defineProperty(this, "serviceLandingStart", function () {
    window.performanceData.serviceLandingTiming = undefined;
    window.performanceData.serviceLandingXmlhttprequestEntries = [];
    performance.mark(_this3.startName);
  });
  _defineProperty(this, "serviceLandingEnd", function () {
    var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var startObserve = performance.getEntriesByName(_this3.startName);
    if (startObserve.length > 0) {
      setParamInfo(detail);
      performance.mark(_this3.endName);
      performance.measure(serviceLandingMeasureName, _this3.startName, _this3.endName);
    }
  });
  this.t = t || new Date().valueOf();
  this.startName = formatMarkName('serviceLanding_start', this.t);
  this.endName = formatMarkName('serviceLanding_end', this.t);
}); //子项目列表Landing
var productListLandingMeasureName = formatMarkName('productListLanding_timing');
var productListLanding = /*#__PURE__*/_createClass(function productListLanding(url) {
  var _this4 = this;
  _classCallCheck(this, productListLanding);
  _defineProperty(this, "url", void 0);
  _defineProperty(this, "startName", void 0);
  _defineProperty(this, "endName", void 0);
  _defineProperty(this, "productListLandingStart", function () {
    window.performanceData.productListLandingTiming = undefined;
    window.performanceData.productListLandingXmlhttprequestEntries = [];
    performance.mark(_this4.startName);
  });
  _defineProperty(this, "productListLandingEnd", function () {
    var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var startObserve = performance.getEntriesByName(_this4.startName);
    if (startObserve.length > 0) {
      setParamInfo(detail);
      performance.mark(_this4.endName);
      performance.measure(productListLandingMeasureName, _this4.startName, _this4.endName);
    }
  });
  this.url = url;
  this.startName = formatMarkName('productListLanding_start', url);
  this.endName = formatMarkName('productListLanding_end', url);
}); //子项目列表
var productListMeasureName = formatMarkName('productList_timing');
var productList = /*#__PURE__*/_createClass(function productList(url) {
  var _this5 = this;
  _classCallCheck(this, productList);
  _defineProperty(this, "url", void 0);
  _defineProperty(this, "startName", void 0);
  _defineProperty(this, "endName", void 0);
  _defineProperty(this, "productListStart", function () {
    window.performanceData.productListTiming = undefined;
    window.performanceData.productListXmlhttprequestEntries = [];
    performance.mark(_this5.startName);
  });
  _defineProperty(this, "productListEnd", function () {
    var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var startObserve = performance.getEntriesByName(_this5.startName);
    if (startObserve.length > 0) {
      setParamInfo(getDetail(detail));
      performance.mark(_this5.endName);
      performance.measure(productListMeasureName, _this5.startName, _this5.endName);
    }
  });
  this.url = url;
  this.startName = formatMarkName('productList_start', url);
  this.endName = formatMarkName('productList_end', url);
}); //Create
var createMeasureName = formatMarkName('create_timing');
var create = /*#__PURE__*/_createClass(function create(createPageSelectors, t) {
  var _this6 = this;
  _classCallCheck(this, create);
  _defineProperty(this, "createPageSelectors", void 0);
  _defineProperty(this, "t", void 0);
  _defineProperty(this, "startName", void 0);
  _defineProperty(this, "endName", void 0);
  _defineProperty(this, "startFlag", void 0);
  _defineProperty(this, "endFlag", void 0);
  _defineProperty(this, "setObserver", function (rootTarget, target, callback, delay) {
    var options = {
      root: rootTarget,
      rootMargin: '0px'
      // threshold: 1.0,
    };
    // https://developer.mozilla.org/zh-CN/docs/Web/API/Intersection_Observer_API
    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(target); //停止对元素的观察

          window.setTimeout(function () {
            callback();
          }, delay ? 50 : 0);
        }
      });
    }, options);
    observer.observe(target);
  });
  _defineProperty(this, "createStart", function () {
    var createPageElement = document.querySelector(_this6.createPageSelectors);
    if (createPageElement) {
      var content = document.createElement('div');
      content.setAttribute('style', 'height:100px;width:100px;pointer-events: none;position: fixed;');
      createPageElement.append(content);
      var startIdentifier = document.createElement('div');
      startIdentifier.setAttribute('style', 'height:10px;width:10px;');
      content.append(startIdentifier);
      _this6.startFlag = true;
      _this6.endFlag = false;
      _this6.setObserver(content, startIdentifier, function () {
        window.performanceData.createTiming = undefined;
        window.performanceData.createXmlhttprequestEntries = [];
        performance.mark(_this6.startName);
      });
    }
  });
  _defineProperty(this, "createEnd", function () {
    var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var createPageElement = document.querySelector(_this6.createPageSelectors);
    if (createPageElement && _this6.endFlag === false) {
      var content = document.createElement('div');
      content.setAttribute('style', 'height:100px;width:100px;pointer-events: none;position: fixed;');
      createPageElement.append(content);
      var endIdentifier = document.createElement('div');
      endIdentifier.setAttribute('style', 'height:10px;width:10px;');
      content.append(endIdentifier);
      _this6.endFlag = true;
      _this6.setObserver(content, endIdentifier, function () {
        var startObserve = performance.getEntriesByName(_this6.startName);
        if (startObserve.length > 0) {
          setParamInfo(getDetail(detail));
          performance.mark(_this6.endName);
          performance.measure(createMeasureName, _this6.startName, _this6.endName);
          stopAddXmlhttprequestEntries();
        }
      }, true);
    }
  });
  this.createPageSelectors = createPageSelectors;
  this.t = t || new Date().valueOf();
  this.startName = formatMarkName('create_start', this.t);
  this.endName = formatMarkName('create_end', this.t);
  this.startFlag = false;
  this.endFlag = false;
});
var getFCP = function getFCP() {
  var _window$performanceDa, _performance, _performance$getEntri, _performance$getEntri2;
  return (_window$performanceDa = window.performanceData.portalTiming) !== null && _window$performanceDa !== void 0 && _window$performanceDa.duration ? (_performance = performance) === null || _performance === void 0 ? void 0 : (_performance$getEntri = _performance.getEntriesByType('paint')) === null || _performance$getEntri === void 0 ? void 0 : (_performance$getEntri2 = _performance$getEntri.find(function (i) {
    return i.name === 'first-contentful-paint';
  })) === null || _performance$getEntri2 === void 0 ? void 0 : _performance$getEntri2.startTime : 0;
};
var init = function init(opts) {
  var paramsInfo = {};
  addSetParamInfoEventListener(function (detail) {
    paramsInfo = _objectSpread(_objectSpread({}, paramsInfo), detail);
  });
  setParamInfo({
    application: opts.application
  });
  performanceObserver = new PerformanceObserver(function (list, observer) {
    list.getEntriesByType('resource').forEach(function (info) {
      if (info.initiatorType === 'xmlhttprequest' && info.name.includes('/api/')) {
        var xmlhttprequestUrlBlacklist = ['/api/collectApi/collect/web/performance'];
        if (xmlhttprequestUrlBlacklist.every(function (url) {
          return url !== info.name;
        })) {
          var xmlhttprequestData = findXmlhttprequestData(info.name);
          var mark = performance.getEntriesByType('mark');
          var touchMarkName;
          var reg = /zen-performance_(\w+)_start_.+/;
          for (var i = mark.length - 1; i >= 0; i--) {
            if (reg.test(mark[i].name)) {
              touchMarkName = mark[i].name.replace(reg, '$1');
              try {
                var _window$performanceDa2;
                (_window$performanceDa2 = window.performanceData["".concat(touchMarkName, "XmlhttprequestEntries")]) === null || _window$performanceDa2 === void 0 ? void 0 : _window$performanceDa2.push(_objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(info))), {}, {
                  xmlhttprequestData: xmlhttprequestData
                }));
              } catch (e) {
                console.log(e);
              }
              break;
            }
          }
        }
      }
    });
    list.getEntriesByName(portalMeasureName).forEach(function (info) {
      window.performanceData.portalTiming = info;
    });
    list.getEntriesByName(dashboardMeasureName).forEach(function (info) {
      var _window$performanceDa3, _window$performanceDa4;
      window.performanceData.dashboardTiming = info;

      // console.log('dashboardTiming', info);

      var params = _objectSpread(_objectSpread({}, paramsInfo), {}, {
        fcp_time: getFCP(),
        timing: (((_window$performanceDa3 = window.performanceData.portalTiming) === null || _window$performanceDa3 === void 0 ? void 0 : _window$performanceDa3.duration) || 0) + (((_window$performanceDa4 = window.performanceData.dashboardTiming) === null || _window$performanceDa4 === void 0 ? void 0 : _window$performanceDa4.duration) || 0),
        detail: [].concat(_toConsumableArray(window.performanceData.portalXmlhttprequestEntries), _toConsumableArray(window.performanceData.dashboardXmlhttprequestEntries))
      });
      window.performanceData.portalTiming = undefined;
      window.performanceData.portalXmlhttprequestEntries = [];
      window.performanceData.dashboardTiming = undefined;
      window.performanceData.dashboardXmlhttprequestEntries = [];

      // console.log(params);

      sendData(opts.sendUrl, params);
    });
    list.getEntriesByName(serviceLandingMeasureName).forEach(function (info) {
      window.performanceData.serviceLandingTiming = info;

      // console.log('serviceLandingTiming', info);
    });

    list.getEntriesByName(productListLandingMeasureName).forEach(function (info) {
      window.performanceData.productListLandingTiming = info;

      // console.log('productListLandingTiming', info);
    });

    list.getEntriesByName(productListMeasureName).forEach(function (info) {
      var _window$performanceDa5, _window$performanceDa6, _window$performanceDa7, _window$performanceDa8;
      window.performanceData.productListTiming = info;

      // console.log('productListTiming', info);

      var params = _objectSpread(_objectSpread({}, paramsInfo), {}, {
        fcp_time: getFCP(),
        timing: (((_window$performanceDa5 = window.performanceData.portalTiming) === null || _window$performanceDa5 === void 0 ? void 0 : _window$performanceDa5.duration) || 0) + (((_window$performanceDa6 = window.performanceData.serviceLandingTiming) === null || _window$performanceDa6 === void 0 ? void 0 : _window$performanceDa6.duration) || 0) + (((_window$performanceDa7 = window.performanceData.productListLandingTiming) === null || _window$performanceDa7 === void 0 ? void 0 : _window$performanceDa7.duration) || 0) + (((_window$performanceDa8 = window.performanceData.productListTiming) === null || _window$performanceDa8 === void 0 ? void 0 : _window$performanceDa8.duration) || 0),
        detail: [].concat(_toConsumableArray(window.performanceData.portalXmlhttprequestEntries), _toConsumableArray(window.performanceData.serviceLandingXmlhttprequestEntries), _toConsumableArray(window.performanceData.productListLandingXmlhttprequestEntries), _toConsumableArray(window.performanceData.productListXmlhttprequestEntries))
      });
      window.performanceData.portalTiming = undefined;
      window.performanceData.portalXmlhttprequestEntries = [];
      window.performanceData.serviceLandingTiming = undefined;
      window.performanceData.serviceLandingXmlhttprequestEntries = [];
      window.performanceData.productListLandingTiming = undefined;
      window.performanceData.productListLandingXmlhttprequestEntries = [];
      window.performanceData.productListTiming = undefined;
      window.performanceData.productListXmlhttprequestEntries = [];

      // console.log(params);
      sendData(opts.sendUrl, params);
    });
    list.getEntriesByName(createMeasureName).forEach(function (info) {
      var _window$performanceDa9, _window$performanceDa10, _window$performanceDa11;
      window.performanceData.createTiming = info;

      // console.log('dashboardTiming', info);

      var params = _objectSpread(_objectSpread({}, paramsInfo), {}, {
        fcp_time: getFCP(),
        timing: (((_window$performanceDa9 = window.performanceData.portalTiming) === null || _window$performanceDa9 === void 0 ? void 0 : _window$performanceDa9.duration) || 0) + (((_window$performanceDa10 = window.performanceData.serviceLandingTiming) === null || _window$performanceDa10 === void 0 ? void 0 : _window$performanceDa10.duration) || 0) + (((_window$performanceDa11 = window.performanceData.createTiming) === null || _window$performanceDa11 === void 0 ? void 0 : _window$performanceDa11.duration) || 0),
        detail: [].concat(_toConsumableArray(window.performanceData.portalXmlhttprequestEntries), _toConsumableArray(window.performanceData.serviceLandingXmlhttprequestEntries), _toConsumableArray(window.performanceData.createXmlhttprequestEntries))
      });
      window.performanceData.portalTiming = undefined;
      window.performanceData.portalXmlhttprequestEntries = [];
      window.performanceData.serviceLandingTiming = undefined;
      window.performanceData.serviceLandingXmlhttprequestEntries = [];
      window.performanceData.createTiming = undefined;
      window.performanceData.createXmlhttprequestEntries = [];

      // console.log(params);

      sendData(opts.sendUrl, params);
    });
  });
  performanceObserver.observe({
    entryTypes: ['measure', 'resource']
  });
  performance.mark(formatMarkName('init'));
};
var zenPerformance = {
  init: init,
  observer: {
    portal: portal,
    serviceLanding: serviceLanding,
    productListLanding: productListLanding,
    productList: productList,
    dashboard: dashboard,
    create: create
  },
  setParamInfo: setParamInfo
};
export default zenPerformance;